module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_2_1-f473f29a354c931caa23a7a05a7f9f38.webp";